/* Landing arbolito — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'arbolito'). */


(function(){
  var fmt=function(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')};
  // galería
  var main=document.getElementById('mainImg');
  document.querySelectorAll('#thumbs button').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('#thumbs button').forEach(function(x){x.classList.remove('on')});
      b.classList.add('on');
      main.src=b.querySelector('img').src;
    });
  });
  // combos
  var small=document.getElementById('ctaSmall'),sp=document.getElementById('stickyPrice');
  document.querySelectorAll('.bundle').forEach(function(l){
    l.addEventListener('click',function(){
      document.querySelectorAll('.bundle').forEach(function(x){x.classList.remove('on')});
      l.classList.add('on');l.querySelector('input').checked=true;
      var p=+l.dataset.price;
      small.textContent=l.dataset.name.split(' · ')[0]+' · '+fmt(p)+' · pagas al recibir';
      sp.textContent=fmt(p);
    });
  });
  // pedido: deja el combo en window.__arbolito_SEL, marca el regalo y abre Releasit (arbolitoTriggerCOD en Shopify)
  function selQty(){var on=document.querySelector('.bundle.on');return on?parseInt(on.getAttribute('data-qty'),10):1}
  window.__arbolito_SEL={qty:selQty()};
  document.querySelectorAll('.bundle').forEach(function(l){l.addEventListener('click',function(){window.__arbolito_SEL={qty:selQty()}})});
  function openOrder(e){
    window.__arbolito_SEL={qty:selQty()};
    try{localStorage.setItem('te_regalo','arbolito|'+Date.now())}catch(err){}
    if(window.arbolitoTriggerCOD){if(e)e.preventDefault();window.arbolitoTriggerCOD();return}
    // fuera de Shopify: bajar al selector de combos
    if(e)e.preventDefault();document.getElementById('comprar').scrollIntoView({behavior:'smooth'});
  }
  document.querySelectorAll('.js-buy').forEach(function(a){a.addEventListener('click',openOrder)});
  // cuenta regresiva real a la fecha de corte (30 nov)
  var cut=new Date(new Date().getFullYear(),10,30,23,59,59);
  var d=Math.max(0,Math.ceil((cut-new Date())/864e5));
  document.getElementById('days').textContent=d;
  // sticky
  var st=document.getElementById('sticky'),buy=document.querySelector('.buy .cta');
  var io=new IntersectionObserver(function(e){st.classList.toggle('show',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)});
  io.observe(buy);
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__arbolito_SEL || {};
    var V = window.ARBOLITO_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__arbolito-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.arbolitoTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
